<script>
  import Chart from "chart.js/auto";
  import { onMount } from "svelte";
  import { urlServeur } from "../conf";

  let chartType = "bar";
  let chartDataLabels = "";
  let chartDatasets = "";
  let ctx;
  let chartCanvas;

  /**
   *
   */
  const fecthData = async () => {
    return fetch(urlServeur + "/api/immeubles/graphcumulbk")
    .then (response => response.json())
    .then(result => {
        chartDataLabels = JSON.parse(result.payload.axe);
        //console.log(chartDataLabels)
        chartDatasets = JSON.parse(result.payload.serie);
        //console.log(chartDatasets)

        ctx = chartCanvas.getContext("2d");
        var chart = new Chart(ctx, {
        type: chartType,
        data: {
            labels: chartDataLabels,
            datasets: [
            {
                label: "tot by etab.",
                backgroundColor: [
                "rgba(255, 99, 132)",
                "rgba(54, 162, 235)",
                "rgba(255, 206, 86)",
                "rgba(75, 192, 192)",
                "rgba(153, 102, 255)",
                "rgba(255, 159, 64)",
                ],
                borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
                ],
                data: chartDatasets,
            },
            ],
        },
        options: {
            legend: {
            display: false,
            position: "bottom",
            labels: {
                fontColor: "#000080",
            },
            },
        },
        });
    })
    .catch(error => {
        console.error('Err recup data via serveur : ',error)
    })


  };

  onMount(async () => {
    await fecthData();
  });
</script>

<div class="row">
<p>PieCumulBk : Chart avec data recupérée via API dans le composant</p>
<canvas id="myChart" bind:this={chartCanvas} />

</div>

